import {referenceConstants, uriConstants} from '../../constants'
import {defaultService} from '../../services'
import {errorMessages} from '../../messages'
import {alertActions} from '../'

export const referenceActions = {
	load,
	detail,
	select,
}

/*********
 로딩
 **********/

function load(params) {
	return async dispatch => {
		dispatch(apiAction(referenceConstants.LOAD_REQUEST))

		const queryString = require('query-string');
		let paramStr = queryString.stringify(params);
		paramStr.length > 0 && (paramStr = "?" + paramStr)

		defaultService.handleService({
			method: 'get',
			endPoint: uriConstants.API_URI + uriConstants.GET_REFERENCE + paramStr,
		})
			.then(
				response => {
					dispatch(apiAction(referenceConstants.LOAD_SUCCESS, response))
				},
				error => {
					dispatch(apiAction(referenceConstants.LOAD_FAILURE, error))
					dispatch(apiError(error))
				}
			)
	}
}

/*********
 상세화면
 **********/
function detail(seq, params) {
	return async dispatch => {
		dispatch(apiAction(referenceConstants.DETAILS_REQUEST))

		const queryString = require('query-string');
		let paramStr = queryString.stringify(params);
		paramStr.length > 0 && (paramStr = "?" + paramStr)

		defaultService.handleService({
			method: 'get',
			endPoint: uriConstants.API_URI + uriConstants.GET_REFERENCE + '/' + seq + paramStr,
		})
			.then(
				response => {
					dispatch(apiAction(referenceConstants.DETAILS_SUCCESS, response))
				},
				error => {
					dispatch(apiAction(referenceConstants.DETAILS_FAILURE, error))
					dispatch(apiError(error))
				}
			)
	}
}

/********
 셀렉트
 ******/

function select(params) {
	return async dipatch => {
		dipatch(request())
	}

	function request() {
		return {
			type: referenceConstants.SEARCH_REQUEST,
			params
		}
	}
}

/**
 * API 액션 함수
 */
function apiAction(type, response = null) {
	let resultObj = {type};
	response && (resultObj.response = response)
	return resultObj;
}

/**
 * API 통신 에러 문구 공통처리
 */
function apiError(error) {
	return alertActions.error({
		title: null,
		message: error.response?.data?.errors?.message ? error.response.data.errors.message : errorMessages.systemError
	})
}
